import React, { useContext, useEffect, useState } from "react";
import Box from "@mui/material/Box";
import { MsalContext } from "../../Contexts/MsalContext";
import Grid from "@mui/material/Grid";
import MonitoringScoreCard from "../../Monitoring/MonitoringScoreCard";
import FeedbackPageTitleBar from "./FeedbackPageTitleBar";
import { RecordingInfoViewModel } from "../../ViewModels/RecordingViewModel";
import MonitoringCallInfoContainer from "../../Monitoring/MonitoringCallInfo/MonitoringCallInfoContainer";
import SingleCallWavBar from "../../Monitoring/SingleCallWavBar";
import CircularProgress from "@mui/material/CircularProgress";

const styles = {
    fullHeight: {
        height: '100%'
    },
    bgColour: {
        backgroundColor: 'rgb(245, 245, 245)'
    }
};

interface IProps {
    view: string;
    callRefId: string;
    setCallRefId: (callRefId: string) => void;
    completeId: number;
    close: () => void;
    status?: string;
    agentHasRepsonded: boolean;
}

export default function FeedbackPage(props: IProps) {
    const { msalFetch } = useContext(MsalContext);
    const [pdf, setpdf] = useState<string>('0');
    const [rescoreCompleteId, setRescoreCompleteId] = useState<number | undefined>(undefined);
    const [selectedCallIndex, setSelectedCallIndex] = useState<number>(0);
    const [recordings, setRecordings] = useState<RecordingInfoViewModel | null>(null);

    useEffect(() => {
        fetchData();
    }, [props.callRefId]);

    const pdfDownload = () => {
        msalFetch(`api/PDFGenerator/CreateScorecardPDF?callRefId=${props.callRefId}&completeId=${props.completeId}`)
            .then(response => response.blob())
            .then(data => {
                console.log(data)
                if (data.type !== "application/problem+json") {
                    var url = window.URL.createObjectURL(data);
                    setpdf(url);
                }
                else {
                    console.log('error', 'An internal server error occured');
                }
            })
            .catch(e => {
                console.log(e);
            });
    }

    const getRecordingsInfo = () => {
        msalFetch(`api/Info/GetRecordingsInfo?systemPk=${props.callRefId}`)
            .then(response => response.json())
            .then(data => setRecordings(data))
    }

    const fetchData = () => {
        pdfDownload();
        getRecordingsInfo();
    }

    return (
        recordings ?
            <Box display="flex"
                sx={{ ...styles.fullHeight, ...styles.bgColour }}
                flexDirection="column"  >
                <Box
                    flexGrow={1}
                    overflow="auto">
                    <Grid
                        container
                        sx={styles.fullHeight}>
                        <Grid
                            size={6}
                            sx={styles.fullHeight}>
                            <Box
                                display="flex"
                                flexDirection="column"
                                sx={styles.fullHeight}>
                                <FeedbackPageTitleBar
                                    callRefId={props.callRefId}
                                    close={props.close} />
                                <Box
                                    flexGrow={1}
                                    overflow="auto"
                                    paddingRight={1}>
                                    {
                                        recordings &&
                                        <MonitoringCallInfoContainer
                                            id={props.callRefId}
                                            setId={props.setCallRefId}
                                            feedbackView={props.view}
                                            setCallRefId={props.setCallRefId}
                                            completeId={props.completeId}
                                            setRescoreCompleteId={setRescoreCompleteId}
                                            setSelectedCallIndex={setSelectedCallIndex}
                                            recordings={recordings}
                                            close={props.close}
                                            agentHasResponded={props.agentHasRepsonded}
                                            mainView={false}
                                        />
                                    }
                                </Box>
                            </Box>
                        </Grid>
                        <Grid
                            size={6}
                            sx={{ height: '100%', overflow: 'hidden' }}>
                            {
                                (props.view === "QA Team Leader" && rescoreCompleteId)
                                    || (props.view === "Team Leader" && props.status === "QA Approval Required") ?
                                    //if challenge upheld show the new rescore scorecard
                                    <MonitoringScoreCard
                                        callRefId={props.callRefId}
                                        scorecardRescoreId={props.view === "Team Leader" ? props.completeId : rescoreCompleteId}
                                        isTeamLeader={props.view === "Team Leader"}
                                    />
                                    :
                                    pdf != '0' &&
                                    <object
                                        width="100%"
                                        height="100%"
                                        data={pdf + "#toolbar=0"}
                                        type="application/pdf" />
                            }
                        </Grid>
                    </Grid>
                </Box>
                <SingleCallWavBar recording={recordings.recordings[selectedCallIndex]} />
            </Box >
            :
            <Grid container justifyContent="center" alignItems="center" height="100vh">
                <Grid>
                    <CircularProgress size={250} />
                </Grid>
            </Grid>
    )
}